import React, { useState } from 'react';

import { BasicInfo, DetailsTab, FilterByObjectTab, OtherTab } from './tabs';
import { Button } from '@/components/ui/button';

import { AritoIcon, AritoFormV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { initialValues, searchSchema } from '../schema';

interface InitialSearchDialogProps {
  open: boolean;
  onClose: () => void;
  onSearch: (values: BanHangPayload) => void;
}

export const InitialSearchDialog: React.FC<InitialSearchDialogProps> = ({ open, onClose, onSearch }) => {
  const [formValues, setFormValues] = useState(initialValues);

  const handleSubmit = (data: BanHangPayload) => {
    onSearch(data);
  };

  const handleDirectSubmit = () => {
    onSearch(formValues);
    onClose();
  };

  return (
    <DialogV2
      open={open}
      onClose={onClose}
      title='Báo cáo bán hàng so sánh bán hàng hai kỳ'
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={false}
      titleIcon={<AritoIcon icon={12} />}
      actions={
        <>
          <Button onClick={handleDirectSubmit} className='bg-main text-white hover:bg-main-dark'>
            <AritoIcon icon={884} />
            <span className='ml-1'>Đồng ý</span>
          </Button>
          <Button onClick={onClose} variant='outline'>
            <AritoIcon icon={885} />
            <span className='ml-1'>Huỷ</span>
          </Button>
        </>
      }
    >
      <AritoFormV2
        mode='add'
        hasAritoActionBar={false}
        schema={searchSchema}
        initialData={initialValues}
        onSubmit={data => {
          setFormValues(data);
          handleSubmit(data);
        }}
        className='w-full'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] w-[800px] min-w-[800px] overflow-y-auto'>
            <BasicInfo />

            <HeaderTabsV2
              tabs={[
                {
                  id: 'details',
                  label: 'Chi tiết',
                  component: <DetailsTab />
                },
                {
                  id: 'filter-by-object',
                  label: 'Lọc theo đối tượng',
                  component: <FilterByObjectTab />
                },
                {
                  id: 'other',
                  label: 'Khác',
                  component: <OtherTab />
                }
              ]}
            />
          </div>
        }
      />
    </DialogV2>
  );
};

export default InitialSearchDialog;
